<template>
  <main class="layout-default">
    <SeoTemplatePreset>
      <NavigationMenu />
      <slot />
      <Footer />
    </SeoTemplatePreset>
  </main>
</template>
